export const MAP_API_KEY = 'AIzaSyBk1Y3RjIlfRt5IyiK_SXuRwuGSQHgSsus';

export const IMAGE_URL = 'https://cardapi.atldmo.ir/';
export const API_URL = IMAGE_URL + 'api/v1/';
export const FAKE_URL = 'https://card.atldmo.ir/front-end/api/';



// WEBPACK FOOTER //
// ./src/config/Config.js